function formatDate(date) {
    var day = date.getDate() - 3;
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    if(day < 1){
      day = 1;
    }
    return `${month}. ${day}, ${year}`;
}

// Setting the text of elements with the data-order-by attribute
document.querySelectorAll('[data-order-by]').forEach(element => {
    element.textContent = formatDate(new Date());
});

